var ClearInput;

ClearInput = (function() {
  function ClearInput() {}

  ClearInput.prototype.clear = function(cross) {
    return this._input(cross).val('').trigger('change');
  };

  ClearInput.prototype.toggleHide = function(input) {
    var group;
    group = input.parents('.control-group');
    if (input.val() === '') {
      return group.addClass('has-empty-value');
    } else {
      return group.removeClass('has-empty-value');
    }
  };

  ClearInput.prototype._input = function(cross) {
    return cross.parents('.control-group').find('input');
  };

  ClearInput.prototype.bind = function() {
    var self;
    self = this;
    $(document).on('click', '[data-clear]', function() {
      return self.clear($(this));
    });
    return $(document).on('change', '.has-clear input', function() {
      return self.toggleHide($(this));
    });
  };

  return ClearInput;

})();

new ClearInput().bind();

$(document).on('turbo:load', function() {
  return $('.has-clear input').each(function(i, e) {
    return new ClearInput().toggleHide($(e));
  });
});
